export const enabledEInvoicingCountries = ['FR']
